import { render, staticRenderFns } from "./domain_options.vue?vue&type=template&id=fd58c712&scoped=true&lang=pug&"
import script from "./domain_options.vue?vue&type=script&lang=js&"
export * from "./domain_options.vue?vue&type=script&lang=js&"
import style0 from "./domain_options.vue?vue&type=style&index=0&id=fd58c712&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd58c712",
  null
  
)

export default component.exports